import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';

export interface IReceiptUploadFormData {
    description: string;
    type: '-1' | '0' | '1' | '2' | '3';
    // userID: number | null;
}

export interface IReceiptUploadFormState {
  value: IReceiptUploadFormData;
};

const initialState: IReceiptUploadFormState = {
  value: {
    description: '',
    type: '-1',
    // userID: null,
  } as IReceiptUploadFormData,
};

export const receiptUploadSlice = createSlice({
  name: 'receiptUpload',
  initialState,
  reducers: {
    updateUploadReceiptData: (state, action: PayloadAction<IReceiptUploadFormData>) => {
      state.value = action.payload;
    },
  },
});

export const { updateUploadReceiptData } = receiptUploadSlice.actions;
export const uploadReceiptState = (state: RootState) => state.receiptUpload.value;

export default receiptUploadSlice.reducer;
